import { render, staticRenderFns } from "./PromptImage.vue?vue&type=template&id=bf158874&scoped=true"
import script from "./PromptImage.vue?vue&type=script&lang=js"
export * from "./PromptImage.vue?vue&type=script&lang=js"
import style0 from "./PromptImage.vue?vue&type=style&index=0&id=bf158874&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf158874",
  null
  
)

export default component.exports